export default "__VITE_ASSET__005f1077__"